

import React, { Component, useEffect, useRef, useState } from "react";

import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";


import { RenderInputFields, SubmitButton, Input, SelectInput, CKEditorInput, SubTab, SubInput } from "../Form/Form";
import { useSelector } from "react-redux";


const Add = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    getValues,
    clearErrors,
    setError,
    control,
  } = useForm();


  const ckEditorRef = useRef();
  const { languages } = useSelector((state) => state.setting);

  const { response, request } = useRequest();
  const { response: currencyResponse, request: currencyRequest } = useRequest()
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);

  const history = useHistory();

  useEffect(() => {
    document.title = "Add Plan - Calevalab";
  }, []);

  useEffect(() => {
    ckEditorRef.current = {};
    if (languages) {
      languages.forEach((lang) => {
        register(`benifits-${lang.code}`, { required: true });
      });
    }
  }, [languages]);

  useEffect(() => {
    if (response) {
      toast.success("Plan has been added successfully.");
      history.push("/plans");
    }
  }, [response]);

  useEffect(() => {
    currencyRequest("GET", "currency/data")
  }, [])

  useEffect(() => {
    if (currencyResponse) {
      setCurrencies(currencyResponse.data)
    }
  }, [currencyResponse])

  const handleCurrencyChange = (e) => {
    const selectedCode = e;

    if (!selectedCode) return;

    const selectedCurrency = currencies?.find(
      (cur) => cur.code === selectedCode
    );

    if (selectedCurrency) {
      setSelectedCurrency(selectedCurrency)
    }
  };



  const onSubmit = (data) => {
    const dataToSend = [];
    const defaultData = {};
    const { name, price, benifits } = data;

    const currency_id = selectedCurrency?._id || null;
    const currency_sign = selectedCurrency?.sign || "";
    const currency_code = selectedCurrency?.code || "";

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      dataToSend.push({
        languageCode: code,
        name: data["name-" + code],
        benifits: data["benifits-" + code],
      });

      if (languages[i].default) {
        defaultData.name = data["name-" + code];
        defaultData.benifits = data["benifits-" + code];
      }
    }

    request("POST", "plan", {
      name: defaultData.name || name,
      price,
      benifits: defaultData.benifits || benifits,
      currency_id,
      currency_sign,
      currency_code,
      langData: dataToSend,
    });
  };


  const InputFields = [
    [
      {
        Component: SelectInput,
        label: "Currency",
        name: "currency",
        registerFields: {
          required: true,
        },
        handleChange: (e) => handleCurrencyChange(e),
        children: [
          { value: "", label: "Select Currency" },
          ...(currencies || []).map((cur) => ({
            value: cur.code,
            label: `${cur?.name}${cur?.sign ? ` (${cur.sign})` : ""}`,
          })),
        ],
        control: control,
      },
      {
        Component: Input,
        label: "Price",
        type: "text",
        name: "price",
        registerFields: {
          required: true,
          pattern: /^[0-9]+(\.[0-9]+)?$/,
        },
        registerFieldsFeedback: {
          pattern: "Price can only contains numbers.",
        },
      },

    ],
  ];

  return (
    <div className="content  d-flex flex-column flex-column-fluid" id="kt_content">
      <Breadcrumb
        title="Add Plan"
        links={[
          { to: "/", name: "Dashboard" },
          { to: "/plans", name: "Back To Plans" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-1"></div>
                <div className="col-xl-10">
                  <h3 className="mb-10 font-weight-bold text-dark">Add New Plan</h3>

                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row"></div>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages?.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>

                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages?.length > 0 &&
                            languages.map((lang, index) => (
                              <>
                                <SubInput
                                  key={index}
                                  index={index}
                                  errors={errors}
                                  register={register}
                                  //   required={lang.default}
                                  required={true}
                                  InputFields={[
                                    [
                                      {
                                        Component: Input,
                                        type: "text",
                                        label: "Name",
                                        name: "name",
                                        colClass: "col-lg-12",
                                        registerFields: {
                                          required: true,
                                        },
                                      },
                                    ],
                                    [{
                                      Component: CKEditorInput,
                                      colClass: "col-xl-12",
                                      label: "Benifits",
                                      name: "benifits",
                                      registerFields: {
                                        required: false,
                                      },
                                      getValues,
                                      setValue,
                                      trigger,
                                      inputData: {
                                        onInstanceReady: (editor) => {
                                          ckEditorRef.current[lang.code] = editor;
                                        },
                                      },
                                      clearErrors,
                                      isEdit: false,
                                    },]
                                  ]}
                                  code={lang.code}
                                />
                              </>
                            ))}
                        </div>
                        <div className="row"></div>
                      </div>
                    </div>
                    <div className="row"></div>

                    <RenderInputFields InputFields={InputFields} errors={errors} register={register} />

                    <SubmitButton handleSubmit={handleSubmit} onSubmit={onSubmit} name="Submit" />
                  </form>
                </div>
                <div className="col-xl-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Add;
